import { GetStaticPaths, GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { getTags } from 'app/services/Api/blog'
import { blogConfig } from 'app/services/Query/blog/blog.query'
import { NextPage } from 'app/types/decalarations/next'
import { getSearchByTagQueryParams } from 'app/utils/helpers/blog.helpers'

import BlogLayout from '~/components/layouts/BlogLayout'
import MainLayout from '~/components/layouts/MainLayout'
import ArticlesByTagView from '~/views/Blog/ArticlesByTagView'

const ArticlesByTagPage: NextPage = () => <ArticlesByTagView />

ArticlesByTagPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <BlogLayout>{page}</BlogLayout>
  </MainLayout>
)

ArticlesByTagPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Search articles by tag'
  }),
  description: intl.formatMessage({
    defaultMessage: 'Discover all the articles with tag'
  })
})

export const getStaticPaths: GetStaticPaths = async () => {
  const tags = await getTags()

  const paths = tags.map(({ slug }) => ({ params: { slug } }))

  return { paths, fallback: true }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const tag = context.params?.slug as string
  const p = context.params?.p as string

  const params = getSearchByTagQueryParams({ tag, p })

  try {
    const queryClient = new QueryClient()

    const { getArticles } = blogConfig
    const articleKey = getArticles.key(params)

    await queryClient.prefetchQuery(articleKey, getArticles.request)

    return {
      props: { dehydratedState: dehydrate(queryClient) }
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default ArticlesByTagPage
